export {default} from "./NoResults";
export * from "./NoResults";
